import type { JSX } from 'react';

/** Pictogramme de fiche fourni pour les conversations liees a une fiche. */
export function IconeDeFiche({ size = 16 }: { size?: number }): JSX.Element {
  return <svg viewBox="0 0 240 240" width={`${size / 16}rem`} height={`${size / 16}rem`} aria-hidden="true" focusable="false">
    <g transform="translate(0,240) scale(0.1,-0.1)" fill="currentColor">
      <path d="M200 1200 l0 -1200 1000 0 1000 0 0 913 0 912 -288 288 -287 287 -713 0 -712 0 0 -1200z m1537 738 l213 -213 0 -737 0 -738 -750 0 -750 0 0 950 0 950 537 0 538 0 212 -212z" />
      <path d="M700 1750 l0 -130 250 0 250 0 0 130 0 130 -250 0 -250 0 0 -130z" />
      <path d="M700 1200 l0 -130 500 0 500 0 0 130 0 130 -500 0 -500 0 0 -130z" />
      <path d="M700 650 l0 -130 500 0 500 0 0 130 0 130 -500 0 -500 0 0 -130z" />
    </g>
  </svg>;
}
